module.exports = __webpack_public_path__ + "static/media/cat_death.ba591358.mp3";